import axios from 'axios';
import { store } from '../store';
import { logout } from '../store/slices/authSlice';
import { showError } from '../components/CustomAlert';

// Frontend API Configuration


// This will use the proxy in development and the production URL in production
export const API_BASE_URL = 'https://cclcusa.org/admin/backend/api';
// export const API_BASE_URL = 'http://localhost:5001/api';





//Ignore this line for now: export const API_BASE_URL = 'https://cclctraining.org/admin/backend/api'; Not working


// Auth headers for fetch-based API calls (applications, sessions, etc.)
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Request interceptor to add auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log('401 error detected:', error.response?.data);
      
      // Check if user is currently authenticated (has token in localStorage)
      const token = localStorage.getItem('token');
      const requestUrl = error.config?.url || '';
      
      // Only handle token expiry for authenticated users
      // Skip for login/signup endpoints (those have their own error handling)
      const isAuthEndpoint = requestUrl.includes('/auth/login') || 
                             requestUrl.includes('/auth/signup');
      
      if (token && !isAuthEndpoint) {
        // Dispatch logout action to update Redux state
        store.dispatch(logout());
        
        // Show error message to user
        showError('Token expired, login again', 'Session Expired');
        
        // Redirect to login page after a short delay to allow message to be seen
        setTimeout(() => {
          window.location.href = '/admin/login';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);


